import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import HttpService from '../../../services/httpService';
import { connect, useSelector } from 'react-redux';
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction';
import { getAllRoles } from '../../../redux/actions/rolesActions';
import {
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  Checkbox,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TablePagination,
  Tooltip,
  Grid,
  Avatar,
  Chip,
  Switch,
  IconButton,
  InputAdornment,
  CircularProgress,
  LinearProgress,
  MenuItem,
  Slide,
  FormControlLabel,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BlockIcon from '@material-ui/icons/Block';
import EditIcon from '@material-ui/icons/Edit';
import SecurityIcon from '@material-ui/icons/Security';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import StarsIcon from '@material-ui/icons/Stars';
import InboxIcon from '@material-ui/icons/Inbox';
import SearchOffIcon from '@material-ui/icons/FindInPage';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import BusinessIcon from '@material-ui/icons/Business';
import Popover from '@material-ui/core/Popover';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import StorefrontIcon from '@material-ui/icons/Storefront';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';

import { Modal } from 'antd';
import { salesDepartment, designDepartment } from '../../../utils';
import * as XLSX from 'xlsx';
import moment from 'moment';

// Shared Decorpot palette - identical constants to ExecutionApprovalList,
// MarketingJunk, cronJobMonitor and leadDesignToExecution, so this page
// recolours with them instead of carrying its own blue.
const ORANGE = '#F47E44';
const ORANGE_DARK = '#c1531f';
const ORANGE_LIGHT = '#fff1ea';
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const INK = '#3d2b21';
const GREEN = '#1e7e34';
const GREEN_DARK = '#19692c';
const GREEN_LIGHT = '#eaf6ee';
const RED = '#a93226';
const RED_LIGHT = '#fdecea';

const ROWS_OPTIONS = [25, 50, 100];

// Roles that see the whole directory AND the destructive actions. Kept as one
// list because the two used to be computed separately from the same names,
// which is how they drift.
const SUPER_ROLES = ['LnD_User', 'Admin'];
const EXTRA_ACTION_ROLES = ['LnD_User', 'Admin', 'Naraci Tech Manager', 'Naraci Tech User'];


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BrandLinearProgress = withStyles(() => ({
  root: { height: 4, borderRadius: 999, backgroundColor: 'rgba(193,83,31,0.10)' },
  bar: { borderRadius: 999, background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, #ff9c66)` },
}))(LinearProgress);

// Mongo refs reach the client either populated or as a bare id, depending on
// which route served them. Reading .['_id'] blind works for the first and
// silently yields undefined for the second.
const idOf = (value) => {
  if (!value) return undefined;
  if (typeof value === 'object') return value._id || undefined;
  return value;
};

// The scoping fields go to a $in, so they must be arrays - a bare string makes
// Mongo throw. Normalised here rather than hoping the shape is right.
const idsOf = (value) => {
  if (!value) return [];
  const list = Array.isArray(value) ? value : [value];
  return list.map(idOf).filter(Boolean);
};

const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$~`_\-*&^%])[A-Za-z\d!@#$~`_\-*&^%]{8,}$/;

// Returns both the label and a colour that actually passes on white. The old
// version used 'lightgreen' (#90ee90), which is 1.4:1 against white - the
// strength readout was effectively invisible at the exact moment it mattered.
const strengthOf = (password) => {
  if (!password) return { label: '', color: '#756e68', score: 0 };
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecial = /[!@#$~`_\-*&^%]/.test(password);
  const longEnough = password.length >= 8;
  if (hasLower && hasUpper && hasDigit && hasSpecial && longEnough) return { label: 'Very Strong', color: GREEN_DARK, score: 100 };
  if (hasLower && hasUpper && hasDigit && hasSpecial) return { label: 'Strong', color: '#2e7d32', score: 80 };
  if (hasLower && hasUpper && hasDigit) return { label: 'Ok', color: '#2c5fb8', score: 60 };
  if (hasLower && hasUpper) return { label: 'Weak', color: '#7a4b00', score: 35 };
  return { label: 'Very Weak', color: RED, score: 15 };
};

const useStyles = makeStyles((theme) => ({
  // Sized to the viewport instead of growing past it, so the only thing that
  // scrolls is the table body. 144px is the app chrome above us: antd Header
  // 64 + Content margin 16*2 + Content padding 24*2 (sidebar.js).
  pageRoot: {
    height: 'calc(100vh - 144px)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    // auto, NOT hidden.
    //
    // Everything below is flex:1 + minHeight:0, so children squash rather
    // than overflow and the page can never decide it needs a scrollbar. Once
    // the banner, hint, filter cards, toolbar and pager - all flexShrink:0 -
    // add up to more than the viewport, the table collapses to nothing and
    // the chrome itself overflows. `hidden` then cut it off with no way to
    // reach it.
    overflow: 'auto',
    [theme.breakpoints.down('xs')]: {
      height: 'auto', minHeight: '100vh', overflow: 'visible',
    },
    // Browser zoom shrinks the CSS viewport: at 150% a 1080px screen reports
    // 720px, and vh shrinks with it. The WIDTH breakpoints above cannot see
    // that - a zoomed 1920px monitor is still 'md' wide - so height needs a
    // ladder of its own.
    '@media (max-height: 640px)': {
      height: 'auto', minHeight: 0, overflow: 'visible', paddingBottom: 32,
    },
  },
  headerBanner: {
    display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0,
    padding: '14px 22px', borderRadius: 16,
    background: HEADER_GRADIENT, color: '#fff',
    boxShadow: '0 8px 24px rgba(93,55,28,0.18)', marginBottom: 12,
    [theme.breakpoints.down('xs')]: { padding: '16px', flexWrap: 'wrap' },
    // Between 640 and 820 the page can still fit, but only if the chrome
    // gives up the room first.
    '@media (max-height: 820px)': { padding: '8px 16px', marginBottom: 8, borderRadius: 12, gap: 12 },
  },
  headerIconWrap: {
    display: 'grid', placeItems: 'center', width: 44, height: 44,
    borderRadius: 14, background: 'rgba(255,255,255,0.18)', flexShrink: 0,
    '@media (max-height: 820px)': { width: 34, height: 34, borderRadius: 10 },
  },
  headerTitle: {
    fontSize: 19, fontWeight: 700, lineHeight: 1.3,
    '@media (max-height: 820px)': { fontSize: 16 },
  },
  headerSubtitle: {
    fontSize: 12.5, color: 'rgba(255,255,255,0.88)', marginTop: 3,
    // First thing to go: it describes the page, which matters least to
    // someone already looking at it.
    '@media (max-height: 820px)': { display: 'none' },
  },
  headerActions: { marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  // A translucent button reads as disabled against the orange banner, so the
  // white treatment is pinned here rather than left to the variant.
  whiteBtn: {
    background: '#fff', color: ORANGE_DARK, fontWeight: 700,
    borderRadius: 10, textTransform: 'none', padding: '6px 16px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.15)', minWidth: 0,
    '&:hover': { background: ORANGE_LIGHT },
    '&.Mui-disabled': { background: 'rgba(255,255,255,0.8)', color: ORANGE_DARK, boxShadow: 'none' },
  },
  excelBtn: {
    background: GREEN, color: '#fff', fontWeight: 700,
    borderRadius: 10, textTransform: 'none', padding: '6px 16px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
    '&:hover': { background: GREEN_DARK },
    '&.Mui-disabled': { background: 'rgba(255,255,255,0.75)', color: '#6b6460', boxShadow: 'none' },
  },
  spin: { animation: '$spin 900ms linear infinite' },
  '@keyframes spin': { from: { transform: 'rotate(0deg)' }, to: { transform: 'rotate(360deg)' } },

  // Reserved rather than conditional, so starting a fetch does not jog the
  // card down by 4px and back again.
  progressSlot: { height: 4, marginBottom: 8, flexShrink: 0 },
  loadingNote: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '7px 13px', marginBottom: 10, borderRadius: 12,
    background: ORANGE_LIGHT, border: `1px solid ${ORANGE}33`, flexShrink: 0,
  },
  loadingNoteTitle: { fontSize: 12.5, fontWeight: 700, color: ORANGE_DARK },
  loadingNoteHint: { fontSize: 11.5, color: '#7a6a60', marginTop: 1 },

  // Takes the remaining height and becomes the next flex context. minHeight:0
  // is load-bearing: without it a flex child refuses to shrink below its
  // content, the card grows past the viewport and the page scrolls again.
  pageCard: {
    flex: 1, minHeight: 0,
    display: 'flex', flexDirection: 'column', overflow: 'hidden',
    borderRadius: 16, background: '#fff',
    border: '1px solid #eceff3', boxShadow: '0 4px 24px rgba(93,55,28,0.08)',
    padding: '14px 16px 0',
    [theme.breakpoints.down('xs')]: { flex: 'none', overflow: 'visible' },
    // A flex:1 child inside an auto-height parent collapses to nothing, so
    // this has to unlock with the root or the table vanishes entirely.
    '@media (max-height: 640px)': { flex: 'none', overflow: 'visible', paddingBottom: 14 },
  },
  statRow: {
    flexShrink: 0, marginBottom: 10,
    '@media (max-height: 820px)': { marginBottom: 6 },
  },
  statCard: {
    position: 'relative', display: 'flex', alignItems: 'center', gap: 12,
    padding: '9px 14px', borderRadius: 14, cursor: 'pointer', outline: 'none',
    '@media (max-height: 820px)': { padding: '5px 12px', gap: 9 },
    border: '2px solid', width: '100%', textAlign: 'left',
    transition: 'transform 200ms ease, box-shadow 200ms ease',
    '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 10px 22px rgba(93,55,28,0.14)' },
    '&:focus-visible': { boxShadow: '0 0 0 3px rgba(244,126,68,0.35)' },
  },
  statCardActive: { transform: 'translateY(-2px)', boxShadow: '0 10px 22px rgba(93,55,28,0.18)' },
  statCheck: { position: 'absolute', top: 7, right: 9, fontSize: 16 },
  statIconWrap: {
    display: 'grid', placeItems: 'center', width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
    '@media (max-height: 820px)': { width: 30, height: 30 },
  },
  statLabel: { fontSize: 11, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', color: '#58616f' },
  statValue: {
    fontSize: 21, fontWeight: 700, color: INK, lineHeight: 1.2,
    '@media (max-height: 820px)': { fontSize: 17 },
  },

  toolbar: { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', flexShrink: 0, marginBottom: 10 },
  searchInputRoot: { borderRadius: 24, background: '#f7f9fc' },
  resultCount: { fontSize: 12.5, color: '#5f6876', fontWeight: 600, marginLeft: 'auto' },
  resetBtn: { borderRadius: 20, textTransform: 'none', fontWeight: 600, color: ORANGE_DARK },

  tableSection: {
    flex: 1, display: 'flex', flexDirection: 'column',
    // The floor, and the half of the fix that makes the other half work.
    // With minHeight:0 the table shrank to zero rows and the root never
    // overflowed, so root's `auto` would never have produced a scrollbar.
    // 300px is a header, four rows and the pager; below that the page gives
    // up and scrolls instead.
    minHeight: 300,
    [theme.breakpoints.down('xs')]: { flex: 'none', display: 'block', minHeight: 0 },
    '@media (max-height: 640px)': { flex: 'none', minHeight: 0 },
  },
  tableScrollArea: {
    flex: 1, minHeight: 0, overflow: 'auto',
    borderRadius: 12, border: '1px solid #eceff3',
    [theme.breakpoints.down('xs')]: { flex: 'none', maxHeight: '60vh' },
    // Once the page itself scrolls, a table that is also a scroller gives you
    // a scrollbar inside a scrollbar.
    '@media (max-height: 640px)': { flex: 'none', overflow: 'visible' },
  },
  headCell: {
    backgroundColor: ORANGE_DARK, color: '#fff',
    fontWeight: 700, fontSize: 12.5, letterSpacing: 0.3,
    borderBottom: 'none', whiteSpace: 'nowrap', padding: '10px 12px',
    // stickyHeader already sets position:sticky/top:0 on head cells - zIndex
    // keeps this background painted above the scrolling rows instead of
    // letting them show through at the seam.
    zIndex: 3,
  },
  row: {
    transition: 'background-color 150ms ease',
    '&:nth-of-type(even)': { backgroundColor: '#fafbfd' },
    '&:hover': { backgroundColor: ORANGE_LIGHT },
  },
  bodyCell: { fontSize: 13, color: INK, padding: '8px 12px' },
  slCell: { fontSize: 12.5, color: '#636c7a', fontWeight: 700, padding: '8px 12px', width: 58 },
  nameCell: { display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 },
  nameAvatar: { width: 30, height: 30, fontSize: 12.5, fontWeight: 700, background: ORANGE_LIGHT, color: ORANGE_DARK, flexShrink: 0 },
  nameMain: { fontSize: 13, fontWeight: 700, color: INK, lineHeight: 1.3 },
  nameSub: {
    fontSize: 11.5, color: '#636c7a', display: 'flex', alignItems: 'center', gap: 4, marginTop: 1,
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  // Department and Team are a hierarchy, not two unrelated strings. Filled
  // chip for the department, outlined for the team inside it - distinct from
  // the orange centre chips and the green/red status, so four chip styles in
  // one row still read as four different kinds of thing.
  deptChip: {
    height: 22, fontSize: 11.5, fontWeight: 700,
    background: '#eef1f5', color: '#4f596a',
    '& .MuiChip-label': { overflow: 'visible', textOverflow: 'clip' },
  },
  teamChip: {
    height: 22, fontSize: 11.5, fontWeight: 600,
    background: 'transparent', color: '#5f6876', border: '1px solid #d6dce5',
    '& .MuiChip-label': { overflow: 'visible', textOverflow: 'clip' },
  },
  ecChip: {
    height: 21, fontSize: 11, fontWeight: 600,
    // Not ORANGE_DARK: that is 4.20:1 on this tint, which fails AA at 11px.
    // #a8450f takes it to 5.40:1 and is visually the same chip.
    background: ORANGE_LIGHT, color: '#a8450f', marginRight: 4, marginBottom: 2,
  },
  muted: { color: '#636c7a', fontStyle: 'italic', fontSize: 12.5 },
  // Click opens the full list, rather than a tooltip that needs a steady hover
  // and vanishes the moment you try to read down it.
  ecMoreChip: {
    height: 21, fontSize: 11, fontWeight: 800, cursor: 'pointer',
    background: '#fff', color: ORANGE_DARK, border: `1px dashed ${ORANGE}`,
    '&:hover': { background: ORANGE_LIGHT },
  },
  ecPopPaper: { borderRadius: 14, padding: '12px 14px', maxWidth: 320, boxShadow: '0 12px 32px rgba(93,55,28,0.18)' },
  ecPopTitle: {
    fontSize: 11, fontWeight: 800, letterSpacing: 0.6, textTransform: 'uppercase',
    color: '#756e68', marginBottom: 9, display: 'flex', alignItems: 'center', gap: 6,
  },
  ecPopWrap: { position: 'relative' },
  ecPopList: {
    display: 'flex', flexWrap: 'wrap', gap: 6,
    maxHeight: 260, overflowY: 'auto', paddingBottom: 2,
  },
  ecPopFade: {
    position: 'absolute', left: 0, right: 0, bottom: 0, height: 40,
    display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    cursor: 'pointer', outline: 'none',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.88) 55%, #fff 100%)',
    '&:hover $ecPopFadePill': { background: ORANGE_DARK, color: '#fff' },
    '&:focus-visible $ecPopFadePill': { boxShadow: '0 0 0 3px rgba(244,126,68,0.35)' },
  },
  ecPopFadePill: {
    display: 'inline-flex', alignItems: 'center', gap: 2,
    fontSize: 10, fontWeight: 800, letterSpacing: 0.3,
    background: '#fff', color: '#a8450f',
    border: `1px solid ${ORANGE}`, borderRadius: 999, padding: '2px 9px',
    boxShadow: '0 2px 6px rgba(93,55,28,0.14)',
    transition: 'background-color 160ms ease, color 160ms ease',
  },

  statusChip: { height: 23, fontSize: 11, fontWeight: 700, borderRadius: 999 },
  // Looks like a control, because it is one. A bare chip that happens to be
  // clickable is invisible as an affordance - people used the Action column
  // or assumed the status was read-only.
  statusChipClickable: {
    cursor: 'pointer',
    border: '1px solid transparent',
    transition: 'box-shadow 160ms ease, transform 160ms ease, border-color 160ms ease',
    '&:hover': { transform: 'translateY(-1px)', boxShadow: '0 4px 10px rgba(93,55,28,0.18)' },
  },

  hintBar: {
    display: 'flex', alignItems: 'flex-start', gap: 10, flexShrink: 0,
    padding: '9px 12px', marginBottom: 10, borderRadius: 12,
    background: '#fff4e2', border: '1px solid #f3d8ab',
    fontSize: 12, color: '#7a4b00', lineHeight: 1.55,
    '@media (max-height: 820px)': { padding: '5px 10px', marginBottom: 6, fontSize: 11.5 },
  },
  hintKey: { fontWeight: 800 },
  hintClose: {
    marginLeft: 'auto', flexShrink: 0, color: '#7a4b00', padding: 4,
    '&:hover': { background: 'rgba(122,75,0,0.10)' },
  },
  actionBtn: {
    padding: 6,
    transition: 'transform 180ms ease, background-color 180ms ease',
    '&:hover': { transform: 'scale(1.12)' },
  },
  emptyStateWrap: { textAlign: 'center', padding: '56px 20px' },
  emptyTitle: { fontSize: 15, fontWeight: 700, color: '#5f6876', marginTop: 10 },
  emptyHint: { fontSize: 12.5, color: '#636c7a', marginTop: 4 },
  // Never squeezed - it sits below the scroll area and must stay reachable.
  pagination: { flexShrink: 0, borderTop: '1px solid #eceff3' },

  // ---- dialogs ------------------------------------------------------------
  dlgPaper: { borderRadius: 18, overflow: 'hidden' },
  dlgHead: {
    display: 'flex', alignItems: 'center', gap: 14, padding: '16px 22px',
    color: '#fff', background: 'linear-gradient(135deg, #9c3d12 0%, #a84315 45%, #c1531f 100%)',
  },
  dlgHeadDanger: { background: 'linear-gradient(135deg, #8e2419 0%, #a8311f 55%, #b5352a 100%)' },
  dlgHeadIcon: {
    width: 42, height: 42, borderRadius: 13, flexShrink: 0,
    display: 'grid', placeItems: 'center', background: 'rgba(255,255,255,0.2)',
  },
  dlgTitle: { fontSize: 17, fontWeight: 700, lineHeight: 1.25 },
  dlgSub: { fontSize: 12, color: 'rgba(255,255,255,0.92)', marginTop: 2 },
  dlgClose: {
    color: '#fff', flexShrink: 0, marginLeft: 'auto',
    transition: 'background-color 200ms ease, transform 200ms ease',
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.18)', transform: 'rotate(90deg)' },
  },
  dlgBody: { padding: '18px 22px 8px' },

  // Contained: the field, the count and the actions read as one control
  // instead of a bare underline with text floating under it.
  pickerBoxOff: { opacity: 0.72, background: '#f5f3f1' },
  pickerBox: {
    borderRadius: 12, border: '1px solid #e6e2df', background: '#fbfaf9',
    padding: 10,
    transition: 'border-color 160ms ease, box-shadow 160ms ease',
    '&:focus-within': { borderColor: ORANGE, boxShadow: `0 0 0 3px ${ORANGE}22` },
    '& .MuiOutlinedInput-root': { background: '#fff' },
  },
  pickerFoot: {
    display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
    marginTop: 8, paddingTop: 7, borderTop: '1px dashed #e6e2df',
  },
  pickerCount: { fontSize: 11.5, color: '#5f6876', marginRight: 'auto' },
  pickerLink: {
    fontSize: 11, fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase',
    color: '#a8450f', cursor: 'pointer', outline: 'none',
    borderBottom: '1px solid transparent',
    '&:hover': { borderBottomColor: '#a8450f' },
    '&:focus-visible': { borderBottomColor: '#a8450f' },
  },
  optionRow: { display: 'flex', alignItems: 'center', gap: 2, fontSize: 13, width: '100%' },
  optionCheck: { padding: 4, marginRight: 4 },
  pickedChip: {
    height: 24, fontSize: 11.5, fontWeight: 600,
    background: '#eef1f5', color: '#4f596a',
    '& .MuiChip-deleteIcon': { color: '#4f596a', fontSize: 15 },
    '& .MuiChip-deleteIcon:hover': { color: '#a93226' },
  },
  dlgActions: { padding: '12px 22px 18px', gap: 8 },
  sectionLabel: {
    display: 'flex', alignItems: 'center', gap: 7, margin: '4px 0 12px',
    fontSize: 11, fontWeight: 800, letterSpacing: 0.7, textTransform: 'uppercase', color: '#756e68',
  },
  sectionRule: { flex: 1, height: 1, background: '#f1eeec' },
  btnGhost: {
    borderRadius: 22, textTransform: 'none', fontWeight: 600, padding: '6px 18px',
    color: '#6b6460', background: '#f3f1ef', boxShadow: 'none',
    '&:hover': { background: '#eae6e3', color: '#6b6460', boxShadow: 'none' },
  },
  btnPrimary: {
    borderRadius: 22, textTransform: 'none', fontWeight: 700, padding: '6px 22px',
    background: ORANGE_DARK, color: '#fff', boxShadow: 'none',
    '&:hover': { background: '#a8450f', color: '#fff', boxShadow: 'none' },
    '&.Mui-disabled': { background: '#e6e2df', color: '#857d77' },
  },
  btnDanger: {
    borderRadius: 22, textTransform: 'none', fontWeight: 700, padding: '6px 22px',
    background: '#b5352a', color: '#fff', boxShadow: 'none',
    '&:hover': { background: '#8e2419', color: '#fff', boxShadow: 'none' },
    '&.Mui-disabled': { background: '#e6e2df', color: '#857d77' },
  },
  strengthTrack: { height: 6, borderRadius: 999, background: '#efebe8', overflow: 'hidden', marginTop: 6 },
  strengthFill: { height: '100%', borderRadius: 999, transition: 'width 260ms ease, background-color 260ms ease' },
  warnBox: {
    display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 14,
    padding: '11px 14px', borderRadius: 12,
    background: '#fff4e2', border: '1px solid #f3d8ab',
    fontSize: 12.5, color: '#7a4b00', lineHeight: 1.5,
  },
  roleRow: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '7px 12px', borderRadius: 10, border: '1px solid #ece8e5',
    transition: 'background-color 150ms ease, border-color 150ms ease',
    '&:hover': { background: ORANGE_LIGHT, borderColor: '#f3c9b2' },
  },
  roleRowOn: { background: GREEN_LIGHT, borderColor: '#bfe3c9' },
  roleName: { fontSize: 13, fontWeight: 600, color: INK },

  // ---- roles modal -------------------------------------------------------
  roleUserCard: {
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '12px 14px', borderRadius: 14, marginBottom: 14,
    background: ORANGE_LIGHT, border: '1px solid #f3c9b2',
  },
  roleUserAvatar: { width: 42, height: 42, fontSize: 16, fontWeight: 700, background: '#fff', color: ORANGE_DARK },
  roleUserName: { fontSize: 15, fontWeight: 700, color: INK, lineHeight: 1.3 },
  roleUserMeta: { fontSize: 12, color: '#7a4b00', marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: '2px 10px' },
  // The answer to "what does this person have right now?" - previously you
  // had to scan every switch in a list of fifty to find out.
  assignedBox: {
    padding: '12px 14px', borderRadius: 14, marginBottom: 14,
    background: GREEN_LIGHT, border: '1px solid #bfe3c9',
  },
  assignedBoxEmpty: { background: '#f7f5f3', border: '1px solid #e6e2df' },
  assignedChips: { display: 'flex', flexWrap: 'wrap', gap: 7 },
  assignedChip: {
    fontWeight: 700, fontSize: 11.5, height: 26,
    background: '#fff', color: GREEN_DARK, border: '1px solid #bfe3c9',
    '& .MuiChip-deleteIcon': { color: GREEN_DARK, fontSize: 16 },
    '& .MuiChip-deleteIcon:hover': { color: '#b5352a' },
  },
  roleGroupLabel: {
    display: 'flex', alignItems: 'center', gap: 8, margin: '16px 0 10px',
    fontSize: 11, fontWeight: 800, letterSpacing: 0.7, textTransform: 'uppercase', color: '#756e68',
  },
  roleGroupCount: {
    fontSize: 10, fontWeight: 800, borderRadius: 999, padding: '1px 8px',
    background: ORANGE_LIGHT, color: '#a8450f',
  },
  roleToolbar: { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' },
  roleScroll: { marginTop: 4 },
  roleEmpty: { padding: '26px 10px', textAlign: 'center', color: '#636c7a', fontSize: 13 },
}));

// Single-select twin of the Locations / Experience Centres pickers: same
// contained box, same footer line, and searchable - a department list is long
// enough that typing beats scrolling.
//
// State here holds IDs, not objects, so the value is looked up on the way in
// and unwrapped on the way out.
const SinglePicker = ({
  classes, label, options, value, onChange,
  idKey = '_id', labelKey = 'name',
  disabled, placeholder, footer, emptyText,
}) => {
  const selected = options.find((o) => o[idKey] === value) || null;
  return (
    <div className={`${classes.pickerBox} ${disabled ? classes.pickerBoxOff : ''}`}>
      <Autocomplete
        size="small"
        disabled={disabled}
        options={options}
        value={selected}
        onChange={(e, v) => onChange(v ? v[idKey] : '')}
        getOptionLabel={(o) => (o && o[labelKey]) || ''}
        getOptionSelected={(o, v) => o[idKey] === v[idKey]}
        noOptionsText={emptyText || 'Nothing matches that'}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={label} placeholder={placeholder} />
        )}
      />
      <div className={classes.pickerFoot}>
        <span className={classes.pickerCount}>{footer}</span>
        {Boolean(value) && !disabled && (
          <span
            role="button"
            tabIndex={0}
            className={classes.pickerLink}
            onClick={() => onChange('')}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onChange(''); } }}
          >
            Clear
          </span>
        )}
      </div>
    </div>
  );
};

const Users = (props) => {
  const classes = useStyles();
  const { rolesList } = useSelector((state) => state.roles);
  const LoggedInUserDetails = useSelector((state) => state.user);
  const me = LoggedInUserDetails?.userDetails;

  const myRoleNames = useMemo(
    () => (me?.roles || []).map((r) => r?.name).filter(Boolean),
    [me]
  );
  // Joined to a string on purpose. fetchUsers below takes these as
  // dependencies, and the user reducer hands back a fresh object on every
  // SET_USER_DETAILS - dispatched from several unrelated places - so depending
  // on `me` itself re-created the callback and refetched the list each time.
  // A string of the same ids compares equal, so the effect stays put.
  const scopeDeptKey = useMemo(() => idsOf(me?.departmentId).join(','), [me]);
  const scopeEcKey = useMemo(() => idsOf(me?.experienceCenterId).join(','), [me]);
  const isSuperUser = myRoleNames.some((n) => SUPER_ROLES.includes(n));
  const canShowExtraActions = myRoleNames.some((n) => EXTRA_ACTION_ROLES.includes(n));

  // ---- list state ---------------------------------------------------------
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_OPTIONS[0]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [users, setUsers] = useState([]);
  const [searchField, setSearchField] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');   // active | inactive | all
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loadError, setLoadError] = useState('');

  // ---- separate loaders, one per thing that can be waited on --------------
  // Previously every one of these went through the global redux spinner, so a
  // background list refresh blocked the whole app and two overlapping requests
  // fought over the same flag.
  const [listLoading, setListLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [savingUser, setSavingUser] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roleBusy, setRoleBusy] = useState('');       // the role name being toggled
  const [promoSaving, setPromoSaving] = useState(false);
  const [statusSaving, setStatusSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [metaLoading, setMetaLoading] = useState(true);

  // ---- form state ---------------------------------------------------------
  const defaultUserDetails = { name: '', mobile: '', email: '', password: '', confirmPassword: '', _id: '' };
  const [addUserModal, setAddUserModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userDetails, setUserDetails] = useState(defaultUserDetails);
  const { name, mobile, email, password, confirmPassword } = userDetails;
  const [showPw, setShowPw] = useState({ password: false, confirmPassword: false });

  const [departmentLists, setDepartmentsList] = useState([]);
  const [dupDepartmentLists, setDupDepartmentList] = useState([]);
  const [department, setSelectedDepartment] = useState('');
  const [departmentorEffectiveDate, setSelectedDepartmentForEffectiveDate] = useState('');
  const [am, setSelectedAM] = useState('');
  const [sm, setSelectedSM] = useState('');
  const [team, setSelectedTeam] = useState('');
  const [teamLists, setTeamList] = useState([]);
  const [amList, setAMList] = useState([]);
  const [smList, setSMList] = useState([]);

  const [cities, setCities] = useState([]);
  const [dumpCities, setDumpCities] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [expcenters, setExpcenters] = useState([]);
  const [dumpExpcenters, setDumpExpcenters] = useState([]);
  const [selectedExpcenters, setSelectedExpcenters] = useState([]);

  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState('');
  const [rolesModal, setRolesModal] = useState(false);
  const [selectedUserRoles, setSelectedUserRoles] = useState([]);
  const [roleSearch, setRoleSearch] = useState('');
  const [onlyAssigned, setOnlyAssigned] = useState(false);

  const [promoModalOpen, setPromoModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [promoMonth, setPromoMonth] = useState('');
  const [promoYear, setPromoYear] = useState('');
  const [selectedUserName, setSelectedUserName] = useState('');

  const [effectiveDateModal, setEffectiveDateModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [startDate, setStartDate] = useState('');

  const [openDeactivateDialog, setOpenDeactivateDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // The row whose full centre list is open. Holds the row, not an id, so the
  // popover keeps rendering through a background refresh of `users`.
  const [ecPopover, setEcPopover] = useState({ el: null, user: null });
  // The popover list scrolls past ~8 centres with nothing to say so - you open
  // it, see a full grid of chips, and assume that is all of them.
  const ecPopRef = useRef(null);
  const [ecMoreBelow, setEcMoreBelow] = useState(false);

  const measureEcPop = useCallback(() => {
    const el = ecPopRef.current;
    if (!el) { setEcMoreBelow(false); return; }
    setEcMoreBelow(el.scrollHeight - el.scrollTop - el.clientHeight > 4);
  }, []);

  // Measured after the popover has actually laid out, not during the click
  // that opens it - at that point the node does not exist yet.
  useEffect(() => {
    if (!ecPopover.el) { setEcMoreBelow(false); return undefined; }
    const t = setTimeout(measureEcPop, 30);
    return () => clearTimeout(t);
  }, [ecPopover, measureEcPop]);

  // Dismissed hints stay dismissed, per browser. Wrapped because localStorage
  // throws outright in a private window with site data blocked, and a hint bar
  // is not worth taking the page down for.
  const [showHint, setShowHint] = useState(() => {
    try { return localStorage.getItem('usersPageHintDismissed') !== '1'; } catch (e) { return true; }
  });
  const dismissHint = () => {
    setShowHint(false);
    try { localStorage.setItem('usersPageHintDismissed', '1'); } catch (e) { /* no-op */ }
  };

  const currentYear = new Date().getFullYear();
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const strength = strengthOf(password);
  const isPasswordShort = password.length > 0 && password.length < 8;
  const isConfirmPasswordMatched = confirmPassword.length === 0 || password === confirmPassword;

  // ---- the one list fetch -------------------------------------------------
  //
  // There used to be two: getUsers() and a separate debounced copy for search.
  // The debounced one left OUT departmentId/experienceCenterId, so typing in
  // the search box silently widened a restricted user's view to the whole
  // directory. One function now builds the payload for every case.
  const fetchUsers = useCallback(async (opts = {}) => {
    const { silent } = opts;
    if (silent) setRefreshing(true); else setListLoading(true);
    try {
      const payload = {
        page,
        rowsPerPage,
        query: debouncedSearch.trim(),
      };
      // 'all' leaves isActive off entirely; the server only filters when the
      // key is present.
      if (statusFilter !== 'all') payload.isActive = statusFilter === 'active';

      // Super users see the whole directory. Everyone else is scoped to their
      // own department and experience centres - as ARRAYS, because the server
      // puts these straight into a $in and a bare string makes Mongo throw.
      if (!isSuperUser) {
        const departmentIds = scopeDeptKey ? scopeDeptKey.split(',') : [];
        const experienceCenterIds = scopeEcKey ? scopeEcKey.split(',') : [];
        if (departmentIds.length) payload.departmentId = departmentIds;
        if (experienceCenterIds.length) payload.experienceCenterId = experienceCenterIds;
      }

      const result = await HttpService.getUsersforUsersPage(payload);
      setUsers(Array.isArray(result?.data?.users) ? result.data.users : []);
      setTotalUsers(Number(result?.data?.totalCount) || 0);
      setLoadError('');
      setLastUpdated(new Date());
    } catch (error) {
      console.error(error);
      setUsers([]);
      setTotalUsers(0);
      // A failed call used to leave an empty table that read exactly like
      // "no users match", which is the opposite of the truth.
      setLoadError(error?.response?.data?.message || error?.message || 'Could not load the user list.');
    }
    setRefreshing(false);
    setListLoading(false);
  }, [page, rowsPerPage, debouncedSearch, statusFilter, isSuperUser, scopeDeptKey, scopeEcKey]);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  // Debounce the TERM, not the request. The effect above then treats a search
  // exactly like any other change of page or filter.
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchField), 400);
    return () => clearTimeout(timer);
  }, [searchField]);

  // Without this, narrowing the list leaves you parked on a page that no
  // longer exists, staring at an empty table.
  useEffect(() => { setPage(0); }, [debouncedSearch, statusFilter, rowsPerPage]);

  // Departments, cities and experience centres are reference data. They used
  // to be refetched on every page change and every filter flip - three extra
  // round trips each time someone clicked "next page".
  const loadMeta = useCallback(async () => {
    setMetaLoading(true);
    const results = await Promise.allSettled([
      HttpService.getDepartments(),
      HttpService.getLocationList(),
      HttpService.getExpericenCenters(),
    ]);
    const [deptRes, locRes, ecRes] = results;

    if (deptRes.status === 'fulfilled') {
      const data = deptRes.value?.data || [];
      setDepartmentsList(data.map((ele) => ({ name: ele.name, _id: ele._id })));
      setDupDepartmentList(data);
    } else {
      console.error('departments:', deptRes.reason);
    }
    if (locRes.status === 'fulfilled') {
      const data = locRes.value?.data || [];
      setCities(data);
      setDumpCities(data.map((ele) => ({ name: ele.name })));
    } else {
      console.error('locations:', locRes.reason);
    }
    if (ecRes.status === 'fulfilled') {
      setExpcenters(ecRes.value?.data || []);
    } else {
      console.error('experience centres:', ecRes.reason);
    }
    // allSettled, so one dead reference list cannot stop the other two from
    // populating and leave the Add User form half-empty with no explanation.
    const failed = results.filter((r) => r.status === 'rejected').length;
    if (failed) props.setSnackInfo(`${failed} reference list${failed === 1 ? '' : 's'} could not be loaded`, 'warning');
    setMetaLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { loadMeta(); }, [loadMeta]);

  // ---- derived ------------------------------------------------------------
  const hasFilter = Boolean(searchField.trim()) || statusFilter !== 'active';
  const busy = listLoading || refreshing;

  const TILES = [
    { key: 'active', label: 'Active', Icon: CheckCircleIcon, color: GREEN_DARK, soft: GREEN_LIGHT },
    { key: 'inactive', label: 'Inactive', Icon: BlockIcon, color: RED, soft: RED_LIGHT },
    { key: 'all', label: 'Everyone', Icon: PeopleAltIcon, color: ORANGE_DARK, soft: ORANGE_LIGHT },
  ];

  // ---- user form ----------------------------------------------------------
  const changeHandler = (e) => {
    const { name: field, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [field]: value }));
  };

  const resetUserForm = () => {
    setUserDetails(defaultUserDetails);
    setSelectedDepartment('');
    setSelectedTeam('');
    setSelectedAM('');
    setSelectedSM('');
    setSelectedCities([]);
    setSelectedExpcenters([]);
    setShowPw({ password: false, confirmPassword: false });
  };

  const closeUserModal = () => {
    setAddUserModal(false);
    setIsEdit(false);
    resetUserForm();
  };

  const selectedLocationIds = () => cities.filter((c) => selectedCities.includes(c.name)).map((c) => c._id);
  const selectedCenterIds = () => expcenters.filter((c) => selectedExpcenters.includes(c.name)).map((c) => c._id);

  const addUser = async () => {
    if (!PASSWORD_RULE.test(password)) {
      props.setSnackInfo('Password needs an uppercase letter, a lowercase letter, a number and one of ! @ # $ ~ ` _ - * & ^ %', 'error');
      return;
    }
    if (password !== confirmPassword) {
      props.setSnackInfo('Passwords do not match', 'error');
      return;
    }
    setSavingUser(true);
    try {
      // Built as a new object rather than assigning onto userDetails - that
      // mutated React state in place, so a failed save left the next attempt
      // carrying fields from the last one.
      const payload = {
        ...userDetails,
        department,
        team,
        locationId: selectedLocationIds(),
        experienceCenterId: selectedCenterIds(),
      };
      if (am) payload.assistantManagerId = am;
      if (sm) payload.managerId = sm;

      await HttpService.addUser(payload);
      props.setSnackInfo('User added successfully', 'success');
      closeUserModal();
      fetchUsers({ silent: true });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
    }
    setSavingUser(false);
  };

  const editUser = async () => {
    setSavingUser(true);
    try {
      const payload = {
        ...userDetails,
        departmentId: department,
        teamId: team,
        locationId: selectedLocationIds(),
        experienceCenterId: selectedCenterIds(),
      };
      if (department === salesDepartment || department === designDepartment) {
        payload.assistantManagerId = am !== '' ? am : null;
      }
      if (department === salesDepartment) {
        payload.managerId = sm !== '' ? sm : null;
      }
      await HttpService.editUser(payload);
      props.setSnackInfo('User updated', 'success');
      closeUserModal();
      // The old version never refetched, so the table went on showing the
      // values you had just changed.
      fetchUsers({ silent: true });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
    }
    setSavingUser(false);
  };

  const getTeamsList = useCallback((deptid) => {
    // Guarded throughout: a department with no matching row, no users or no
    // teams used to throw on teams[0]['users'] and kill the dialog.
    const dept = (dupDepartmentLists || []).find((ele) => ele._id === deptid);
    const deptUsers = dept?.users || [];
    setAMList(
      deptUsers
        .filter((u) => (u.roles || []).some((r) => r.name === 'Assistant Sales Manager' || r.name === 'Assistant Design Manager'))
        .map((u) => ({ id: u._id, name: u.name }))
    );
    setSMList(
      deptUsers
        .filter((u) => (u.roles || []).some((r) => r.name === 'Sales Manager'))
        .map((u) => ({ id: u._id, name: u.name }))
    );
    setTeamList((dept?.teams || []).filter((t) => t.isActive === true));
  }, [dupDepartmentLists]);

  const getUserById = async (id) => {
    setLoadingUser(true);
    setIsEdit(true);
    setAddUserModal(true);
    try {
      const result = await HttpService.getUserById(id);
      const data = result.data || {};
      setSelectedDepartment('');
      setSelectedTeam('');
      setSelectedAM('');
      setSelectedSM('');

      if (data.departmentId) {
        const deptId = idOf(data.departmentId);
        setSelectedDepartment(deptId);
        getTeamsList(deptId);
        setSelectedTeam(idOf(data.teamId) || '');
        setSelectedAM(idOf(data.assistantManagerId) || '');
        setSelectedSM(idOf(data.managerId) || '');
      }

      const cityNames = (data.locationId || []).map((ele) => ele?.name).filter(Boolean);
      setSelectedCities(cityNames);
      const ecNames = (data.experienceCenterId || []).map((ele) => ele?.name).filter(Boolean);
      // Union of what their cities allow AND what they already hold. Filtering
      // on cities alone hid a centre the user is actually assigned to - it
      // stayed selected but had no option to match, so saving silently
      // dropped it.
      const inScope = (expcenters || [])
        .filter((ec) => cityNames.includes(ec?.locationId?.name))
        .map((ec) => ec.name);
      setDumpExpcenters(
        Array.from(new Set([...inScope, ...ecNames])).map((n) => ({ name: n }))
      );
      setSelectedExpcenters(ecNames);

      setUserDetails({
        name: data.name || '',
        mobile: data.mobile || '',
        email: data.email || '',
        _id: data._id || '',
        password: '',
        confirmPassword: '',
      });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
      closeUserModal();
    }
    setLoadingUser(false);
  };

  const changeDepartmentHandler = (event) => {
    setSelectedDepartment(event.target.value);
    setSelectedTeam('');
    setSelectedAM('');
    setSelectedSM('');
    getTeamsList(event.target.value);
  };

  const getExperienceCenterByLocation = (value) => {
    setSelectedCities(value);
    const inScope = (expcenters || []).filter((ec) => value.includes(ec?.locationId?.name));
    setDumpExpcenters(inScope.map((ec) => ({ name: ec.name })));
    // Keep whatever was already picked that is still in scope, drop the rest.
    setSelectedExpcenters((prev) => prev.filter((n) => inScope.some((ec) => ec.name === n)));
  };

  // ---- roles --------------------------------------------------------------
  const openRoleModal = async (id) => {
    setRolesLoading(true);
    setRolesModal(true);
    try {
      const result = await HttpService.getUserById(id);
      const data = result.data || {};
      setSelectedDepartmentForEffectiveDate(data.departmentId?.name || '');
      setUserDetails({
        name: data.name || '', mobile: data.mobile || '', email: data.email || '',
        _id: data._id || '', password: '', confirmPassword: '',
      });
      setSelectedUserRoles((data.roles || []).map((role) => role.name));
      await props.getAllRoles();
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
      setRolesModal(false);
    }
    setRolesLoading(false);
  };

  // Opening fresh, as opposed to the silent refetch openRoleModal also does
  // after every toggle - that one must leave the search box and the filter
  // exactly where the person left them.
  const openRolesFor = (id) => {
    setRoleSearch('');
    setOnlyAssigned(false);
    openRoleModal(id);
  };

  const handleCheck = async (action, roleName) => {
    setRoleBusy(roleName);
    try {
      const role = (rolesList || []).find((r) => r.name === roleName);
      if (!role) throw new Error(`Role "${roleName}" is no longer in the role list`);
      await HttpService.editUserRole({ action, roleId: role._id, userId: userDetails._id });
      props.setSnackInfo('User role updated', 'success');
      // Optimistic, then reconciled by the refetch below - the checkbox used
      // to sit unchanged until a full round trip had finished.
      setSelectedUserRoles((prev) => (action ? [...prev, roleName] : prev.filter((n) => n !== roleName)));
      await openRoleModal(userDetails._id);
      fetchUsers({ silent: true });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? error.message ?? 'Something went wrong', 'error');
    }
    setRoleBusy('');
  };

  const handleRoleToggle = (action, role) => {
    if (action && (departmentorEffectiveDate === 'Design' || departmentorEffectiveDate === 'Sales')) {
      setSelectedRole(role);
      setSelectedAction(action);
      setEffectiveDateModal(true);
      return;
    }
    handleCheck(action, role);
  };

  const handleSaveEffectiveDate = async () => {
    if (!startDate) {
      props.setSnackInfo('Please select a From date', 'warning');
      return;
    }
    setRoleBusy(selectedRole || 'x');
    try {
      const role = (rolesList || []).find((r) => r.name === selectedRole);
      if (!role) throw new Error('That role is no longer in the role list');
      await HttpService.editUserRole({ action: selectedAction, roleId: role._id, userId: userDetails._id, startDate });
      props.setSnackInfo('User role updated', 'success');
      setEffectiveDateModal(false);
      setStartDate('');
      await openRoleModal(userDetails._id);
      fetchUsers({ silent: true });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? error.message ?? 'Something went wrong', 'error');
    }
    setRoleBusy('');
  };

  // ---- status / delete / promo -------------------------------------------
  const handleOpenDeactivate = (user) => {
    setSelectedUser(user);
    setOpenDeactivateDialog(true);
  };

  const handleCloseDeactivate = () => {
    setOpenDeactivateDialog(false);
    setSelectedUser(null);
  };

  const setIsActiveUser = async () => {
    if (!selectedUser?._id) return;
    setStatusSaving(true);
    try {
      await HttpService.inActiveUser(selectedUser._id);
      props.setSnackInfo(selectedUser.isActive ? 'User deactivated' : 'User reactivated', 'success');
      handleCloseDeactivate();
      fetchUsers({ silent: true });
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
    }
    setStatusSaving(false);
  };

  const handleUserDelete = async () => {
    setDeleting(true);
    try {
      await HttpService.deleteUser(userId);
      props.setSnackInfo('User deleted', 'success');
      setOpen(false);
      fetchUsers({ silent: true });
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? 'Something went wrong', 'error');
    }
    setDeleting(false);
  };

  const openPromoModal = (id, userName) => {
    setSelectedUserId(id);
    setSelectedUserName(userName);
    setPromoModalOpen(true);
  };

  const handleClosePromoModal = () => {
    setPromoModalOpen(false);
    setPromoMonth('');
    setPromoYear('');
  };

  const handlePromoSubmit = async () => {
    if (!promoMonth || !promoYear) {
      props.setSnackInfo('Please select a month and a year', 'warning');
      return;
    }
    setPromoSaving(true);
    try {
      const res = await HttpService.assignPromotionalRole({ userId: selectedUserId, month: promoMonth, year: promoYear });
      props.setSnackInfo(res?.data?.message || 'Promotional role assigned', 'success');
      handleClosePromoModal();
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message ?? 'Failed to assign promotional role', 'error');
    }
    setPromoSaving(false);
  };

  const getAllActiveUserInOnce = async () => {
    setDownloading(true);
    try {
      const response = await HttpService.getAllActiveUserInOnce();
      const rows = response?.data?.data || [];
      if (!rows.length) {
        props.setSnackInfo('There are no active users to export', 'warning');
        setDownloading(false);
        return;
      }
      const excelData = rows.map((user) => ({
        Name: user?.name,
        Email: user?.email,
        Mobile: user?.mobile,
        Roles: (user?.roles || []).join(', '),
        Department: user?.department || '',
        Team: user?.team || '',
        'Assistant Manager': user?.assistantManager || '',
        Locations: (user?.locations || []).join(', '),
        'Experience Centers': (user?.experienceCenters || []).join(', '),
        'Created At': user?.createdAt ? moment(user.createdAt).format('DD-MM-YYYY') : 'N/A',
      }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(excelData), 'Users');
      XLSX.writeFile(workbook, `Active_Users_${moment().format('DD-MM-YYYY')}.xlsx`);
      props.setSnackInfo(`${rows.length} active users exported`, 'success');
    } catch (err) {
      console.error('Error fetching active users:', err);
      // The old version swallowed this entirely - the button simply stopped
      // saying "Downloading..." and nothing arrived.
      props.setSnackInfo(err?.response?.data?.message ?? 'Could not download the user list', 'error');
    }
    setDownloading(false);
  };

  // ---- render helpers -----------------------------------------------------
  const renderEmptyState = () => {
    if (loadError) {
      return (
        <div className={classes.emptyStateWrap}>
          <ErrorOutlineIcon style={{ fontSize: 46, color: '#e8a49c' }} />
          <div className={classes.emptyTitle}>Could not load users</div>
          <div className={classes.emptyHint}>{loadError}</div>
          <Button size="small" className={classes.resetBtn} startIcon={<RefreshIcon />} style={{ marginTop: 12 }} onClick={() => fetchUsers()}>
            Try again
          </Button>
        </div>
      );
    }
    if (hasFilter) {
      return (
        <div className={classes.emptyStateWrap}>
          <SearchOffIcon style={{ fontSize: 46, color: '#c9d2de' }} />
          <div className={classes.emptyTitle}>No users match this view</div>
          <div className={classes.emptyHint}>Try a different name, or clear the filters.</div>
          <Button
            size="small" className={classes.resetBtn} startIcon={<ClearIcon />} style={{ marginTop: 12 }}
            onClick={() => { setSearchField(''); setStatusFilter('active'); }}
          >
            Clear filters
          </Button>
        </div>
      );
    }
    return (
      <div className={classes.emptyStateWrap}>
        <InboxIcon style={{ fontSize: 46, color: '#c9d2de' }} />
        <div className={classes.emptyTitle}>No users yet</div>
        <div className={classes.emptyHint}>Create one with the button above.</div>
      </div>
    );
  };

  const COLUMN_COUNT = 8;

  return (
    <div className={classes.pageRoot}>
      <div className={classes.headerBanner}>
        <div className={classes.headerIconWrap}><PeopleAltIcon style={{ fontSize: 24 }} /></div>
        <div style={{ minWidth: 0 }}>
          <div className={classes.headerTitle}>User Management</div>
          <div className={classes.headerSubtitle}>
            {isSuperUser
              ? 'Everyone in the ERP — accounts, departments, roles and access.'
              : 'Accounts in your department and experience centres.'}
          </div>
        </div>
        <div className={classes.headerActions}>
          <Tooltip title="Reload the list">
            <span>
              <Button
                className={classes.whiteBtn}
                size="small"
                disabled={busy}
                startIcon={<RefreshIcon className={refreshing ? classes.spin : undefined} />}
                onClick={() => fetchUsers({ silent: true })}
              >
                {refreshing ? 'Refreshing' : 'Refresh'}
              </Button>
            </span>
          </Tooltip>
          <Button
            className={classes.excelBtn}
            size="small"
            disabled={downloading}
            startIcon={downloading
              ? <CircularProgress size={15} thickness={5} style={{ color: '#6b6460' }} />
              : <GetAppIcon />}
            onClick={getAllActiveUserInOnce}
          >
            {downloading ? 'Preparing…' : 'Active Users'}
          </Button>
          <Button
            className={classes.whiteBtn}
            size="small"
            startIcon={<PersonAddIcon />}
            onClick={() => { resetUserForm(); setIsEdit(false); setAddUserModal(true); }}
          >
            Create User
          </Button>
        </div>
      </div>

      <div className={classes.progressSlot}>{busy ? <BrandLinearProgress /> : null}</div>

      {busy && (
        <div className={classes.loadingNote}>
          <CircularProgress size={15} thickness={5} style={{ color: ORANGE_DARK }} />
          <div>
            <div className={classes.loadingNoteTitle}>
              {refreshing ? 'Refreshing users…' : 'Fetching users…'}
            </div>
            <div className={classes.loadingNoteHint}>
              Page {page + 1}, {rowsPerPage} per page
              {debouncedSearch.trim() ? ` · matching “${debouncedSearch.trim()}”` : ''}
              {statusFilter !== 'all' ? ` · ${statusFilter} only` : ''}
            </div>
          </div>
        </div>
      )}

      <div className={classes.pageCard}>
        {showHint && (
          <div className={classes.hintBar}>
            <InfoOutlinedIcon style={{ fontSize: 17, flexShrink: 0, marginTop: 1 }} />
            <span>
              <span className={classes.hintKey}>Tips:</span>{' '}
              the three cards above filter the list &middot;{' '}
              {canShowExtraActions
                ? <>click a <span className={classes.hintKey}>status chip</span> to activate or deactivate someone &middot;{' '}</>
                : null}
              a <span className={classes.hintKey}>+N</span> badge opens that person&rsquo;s full list of experience centres &middot;{' '}
              search matches the name only.
            </span>
            <Tooltip title="Hide these tips">
              <IconButton size="small" className={classes.hintClose} onClick={dismissHint} aria-label="hide tips">
                <ClearIcon style={{ fontSize: 15 }} />
              </IconButton>
            </Tooltip>
          </div>
        )}

        <Grid container spacing={2} className={classes.statRow}>
          {TILES.map((tile) => {
            const active = statusFilter === tile.key;
            const TileIcon = tile.Icon;
            return (
              <Grid item xs={4} key={tile.key}>
                <div
                  role="button"
                  tabIndex={0}
                  aria-pressed={active}
                  className={`${classes.statCard} ${active ? classes.statCardActive : ''}`}
                  style={{ borderColor: active ? tile.color : 'transparent', background: tile.soft }}
                  onClick={() => setStatusFilter(tile.key)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setStatusFilter(tile.key); } }}
                >
                  <span className={classes.statIconWrap} style={{ background: '#fff', color: tile.color }}>
                    <TileIcon style={{ fontSize: 20 }} />
                  </span>
                  <span style={{ minWidth: 0 }}>
                    <span className={classes.statLabel} style={{ display: 'block' }}>{tile.label}</span>
                    {/* The count is only meaningful for the view actually
                        loaded - the server returns one total per query, not a
                        breakdown, so showing a number under the other two
                        tiles would be a guess. */}
                    <span className={classes.statValue} style={{ display: 'block' }}>
                      {active ? (busy ? '—' : totalUsers) : 'View'}
                    </span>
                  </span>
                  {active && <CheckCircleIcon className={classes.statCheck} style={{ color: tile.color }} />}
                </div>
              </Grid>
            );
          })}
        </Grid>

        <div className={classes.toolbar}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Search by name"
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
            style={{ minWidth: 300, flex: '0 1 400px' }}
            InputProps={{
              classes: { root: classes.searchInputRoot },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: '#9aa5b1', fontSize: 19 }} />
                </InputAdornment>
              ),
              endAdornment: searchField ? (
                <InputAdornment position="end">
                  {/* A spinner while the debounce has not settled, so a slow
                      typist can tell the list is about to change. */}
                  {searchField !== debouncedSearch
                    ? <CircularProgress size={15} thickness={5} style={{ color: ORANGE_DARK, marginRight: 4 }} />
                    : null}
                  <IconButton size="small" onClick={() => setSearchField('')} aria-label="clear search">
                    <ClearIcon style={{ fontSize: 16 }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
          />
          {hasFilter && (
            <Button
              size="small" className={classes.resetBtn} startIcon={<ClearIcon style={{ fontSize: 15 }} />}
              onClick={() => { setSearchField(''); setStatusFilter('active'); }}
            >
              Clear filters
            </Button>
          )}
          <span className={classes.resultCount}>
            {busy ? 'Loading…' : (
              <>
                {totalUsers === 0 ? 'No users' : `${page * rowsPerPage + 1}–${Math.min((page + 1) * rowsPerPage, totalUsers)} of ${totalUsers}`}
                {lastUpdated ? ` · updated ${moment(lastUpdated).format('h:mm A')}` : ''}
              </>
            )}
          </span>
        </div>

        <div className={classes.tableSection}>
          <TableContainer className={classes.tableScrollArea}>
            <Table size="small" stickyHeader aria-label="users">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headCell}>Sl No</TableCell>
                  <TableCell className={classes.headCell}>Name</TableCell>
                  <TableCell className={classes.headCell}>Email</TableCell>
                  <TableCell className={classes.headCell}>Department</TableCell>
                  <TableCell className={classes.headCell}>Team</TableCell>
                  <TableCell className={classes.headCell}>Experience Centre</TableCell>
                  <TableCell className={classes.headCell}>Status</TableCell>
                  <TableCell className={classes.headCell} align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listLoading ? (
                  [...Array(8)].map((_, i) => (
                    <TableRow key={`sk-${i}`}>
                      {[...Array(COLUMN_COUNT)].map((__, j) => (
                        <TableCell key={`sk-${i}-${j}`} className={classes.bodyCell}>
                          <Skeleton variant="text" height={22} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : users.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={COLUMN_COUNT} style={{ borderBottom: 'none' }}>
                      {renderEmptyState()}
                    </TableCell>
                  </TableRow>
                ) : (
                  users.map((data, i) => {
                    // experienceCenterId is only populated when the row has
                    // any; the old code mapped it unguarded and crashed the
                    // whole page on the first user without one.
                    const ecs = (data?.experienceCenterId || []).map((el) => el?.name).filter(Boolean);
                    return (
                      <TableRow key={data?._id || i} className={classes.row}>
                        {/* Continuous across pages. It used to restart at 1 on
                            every page, so row 1 of page 3 read as "1". */}
                        <TableCell className={classes.slCell}>{page * rowsPerPage + i + 1}</TableCell>
                        <TableCell className={classes.bodyCell}>
                          <span className={classes.nameCell}>
                            <Avatar className={classes.nameAvatar}>
                              {String(data?.name || '?').trim().charAt(0).toUpperCase()}
                            </Avatar>
                            <span style={{ minWidth: 0 }}>
                              <div className={classes.nameMain}>{data?.name || '—'}</div>
                              {data?.mobile && (
                                <div className={classes.nameSub}>
                                  <PhoneIcon style={{ fontSize: 12 }} />{data.mobile}
                                </div>
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.bodyCell} style={{ whiteSpace: 'nowrap' }}>
                          {data?.email || <span className={classes.muted}>—</span>}
                        </TableCell>
                        <TableCell className={classes.bodyCell} style={{ whiteSpace: 'nowrap' }}>
                          {data?.departmentId?.name
                            ? <Chip size="small" label={data.departmentId.name} className={classes.deptChip} />
                            : <span className={classes.muted}>Unassigned</span>}
                        </TableCell>
                        <TableCell className={classes.bodyCell} style={{ whiteSpace: 'nowrap' }}>
                          {data?.teamId?.name
                            ? <Chip size="small" label={data.teamId.name} className={classes.teamChip} />
                            : <span className={classes.muted}>—</span>}
                        </TableCell>
                        <TableCell className={classes.bodyCell} style={{ maxWidth: 250 }}>
                          {ecs.length === 0 ? <span className={classes.muted}>None</span> : (
                            <>
                              {/* Two inline keeps the row height even. The rest
                                  are one click away in a popover rather than a
                                  tooltip - a hover target you have to hold
                                  still on is no way to read eleven names. */}
                              {ecs.slice(0, 2).map((n) => (
                                <Tooltip key={n} title={n}><Chip size="small" label={n} className={classes.ecChip} /></Tooltip>
                              ))}
                              {ecs.length > 2 && (
                                <Tooltip title={`Show all ${ecs.length} experience centres`}>
                                  <Chip
                                    size="small"
                                    label={`+${ecs.length - 2} more`}
                                    className={classes.ecMoreChip}
                                    onClick={(e) => setEcPopover({ el: e.currentTarget, user: data })}
                                  />
                                </Tooltip>
                              )}
                            </>
                          )}
                        </TableCell>
                        <TableCell className={classes.bodyCell}>
                          <Tooltip title={canShowExtraActions
                            ? (data?.isActive ? 'Click to deactivate this user' : 'Click to reactivate this user')
                            : 'Only Admin, L&D and Naraci Tech can change this'}>
                            {/* Wrapped in a span so the Tooltip still gets a
                                hoverable target when the chip is not clickable
                                - MUI cannot attach a ref to a disabled-looking
                                chip otherwise. */}
                            <span>
                              <Chip
                                size="small"
                                className={`${classes.statusChip} ${canShowExtraActions ? classes.statusChipClickable : ''}`}
                                label={data?.isActive ? 'Active' : 'Inactive'}
                                // The hand icon is the affordance: it says
                                // "this is a control" without a legend.
                                icon={canShowExtraActions
                                  ? <TouchAppIcon style={{ fontSize: 14, color: data?.isActive ? GREEN_DARK : RED }} />
                                  : undefined}
                                style={data?.isActive
                                  ? { background: GREEN_LIGHT, color: GREEN_DARK, borderColor: '#bfe3c9' }
                                  : { background: RED_LIGHT, color: RED, borderColor: '#f4c7c1' }}
                                onClick={canShowExtraActions ? () => handleOpenDeactivate(data) : undefined}
                              />
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell className={classes.bodyCell} align="center">
                          <div style={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                            <Tooltip title="Edit user">
                              <IconButton size="small" className={classes.actionBtn} onClick={() => getUserById(data._id)}>
                                <EditIcon style={{ fontSize: 18, color: ORANGE_DARK }} />
                              </IconButton>
                            </Tooltip>
                            {canShowExtraActions && (
                              <>
                                <Tooltip title="Change roles">
                                  <IconButton size="small" className={classes.actionBtn} onClick={() => openRolesFor(data._id)}>
                                    <SecurityIcon style={{ fontSize: 18, color: '#2c5fb8' }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Assign promotional role">
                                  <IconButton size="small" className={classes.actionBtn} onClick={() => openPromoModal(data._id, data.name)}>
                                    <StarsIcon style={{ fontSize: 18, color: '#7a4b00' }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={data?.isActive ? 'Deactivate user' : 'Reactivate user'}>
                                  <IconButton size="small" className={classes.actionBtn} onClick={() => handleOpenDeactivate(data)}>
                                    <BlockIcon style={{ fontSize: 18, color: data?.isActive ? '#7a4b00' : GREEN_DARK }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete user permanently">
                                  <IconButton size="small" className={classes.actionBtn} onClick={() => { setUserId(data._id); setOpen(true); }}>
                                    <DeleteOutlineIcon style={{ fontSize: 18, color: RED }} />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className={classes.pagination}
            component="div"
            count={totalUsers}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(_, next) => setPage(next)}
            onChangeRowsPerPage={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            rowsPerPageOptions={ROWS_OPTIONS}
          />
        </div>
      </div>

      {/* Full experience-centre list for one row. */}
      <Popover
        open={Boolean(ecPopover.el)}
        anchorEl={ecPopover.el}
        onClose={() => setEcPopover({ el: null, user: null })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        classes={{ paper: classes.ecPopPaper }}
      >
        <div className={classes.ecPopTitle}>
          <StorefrontIcon style={{ fontSize: 14 }} />
          {(ecPopover.user?.experienceCenterId || []).length} centres &middot; {ecPopover.user?.name || ''}
        </div>
        <div className={classes.ecPopWrap}>
          <div className={classes.ecPopList} ref={ecPopRef} onScroll={measureEcPop}>
            {(ecPopover.user?.experienceCenterId || []).map((ec) => (
              <Chip key={ec?._id || ec?.name} size="small" label={ec?.name} className={classes.ecChip} />
            ))}
          </div>
          {/* Fades the last row of chips rather than cutting it off square,
              which is what made the grid look complete. */}
          {ecMoreBelow && (
            <div
              role="button"
              tabIndex={0}
              aria-label="Scroll to see more centres"
              className={classes.ecPopFade}
              onClick={() => ecPopRef.current && ecPopRef.current.scrollBy({ top: 140, behavior: 'smooth' })}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ecPopRef.current && ecPopRef.current.scrollBy({ top: 140, behavior: 'smooth' }); } }}
            >
              <span className={classes.ecPopFadePill}>
                <KeyboardArrowDownIcon style={{ fontSize: 14 }} />
                more below
              </span>
            </div>
          )}
        </div>
      </Popover>

      {/* ---------------------------- add / edit ---------------------------- */}
      <Dialog
        open={addUserModal}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="sm"
        onClose={closeUserModal}
        classes={{ paper: classes.dlgPaper }}
      >
        <div className={classes.dlgHead}>
          <div className={classes.dlgHeadIcon}>{isEdit ? <EditIcon /> : <PersonAddIcon />}</div>
          <div style={{ minWidth: 0 }}>
            <div className={classes.dlgTitle}>{isEdit ? 'Edit User' : 'Create New User'}</div>
            <div className={classes.dlgSub}>
              {isEdit ? (name || 'Loading…') : 'Account details, placement and access'}
            </div>
          </div>
          <IconButton size="small" className={classes.dlgClose} onClick={closeUserModal} aria-label="close">
            <ClearIcon fontSize="small" />
          </IconButton>
        </div>

        {(loadingUser || metaLoading) && <BrandLinearProgress />}

        <DialogContent className={classes.dlgBody}>
          {loadingUser ? (
            <div style={{ padding: '26px 0' }}>
              {[...Array(5)].map((_, i) => <Skeleton key={i} height={44} />)}
            </div>
          ) : (
            <>
              <div className={classes.sectionLabel}>
                <MailOutlineIcon style={{ fontSize: 14 }} /> Account <span className={classes.sectionRule} />
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField label="Name" value={name} size="small" fullWidth name="name" onChange={changeHandler} variant="outlined" required />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Contact Number" size="small" fullWidth value={mobile} name="mobile" onChange={changeHandler} variant="outlined" required />
                </Grid>
                <Grid item xs={12}>
                  <TextField label="Email" size="small" fullWidth value={email} name="email" type="email" onChange={changeHandler} variant="outlined" required />
                </Grid>
              </Grid>

              <div className={classes.sectionLabel} style={{ marginTop: 18 }}>
                <BusinessIcon style={{ fontSize: 14 }} /> Placement <span className={classes.sectionRule} />
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <SinglePicker
                    classes={classes}
                    label="Department"
                    placeholder="Type to search"
                    options={departmentLists}
                    value={department}
                    // Goes through the existing handler, which also resets the
                    // team, AM and SM - they all belong to the old department.
                    onChange={(id) => changeDepartmentHandler({ target: { value: id } })}
                    footer={`${departmentLists.length} departments · narrows the team list`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SinglePicker
                    classes={classes}
                    label="Team"
                    placeholder={department ? 'Type to search' : 'Pick a department first'}
                    options={teamLists}
                    value={team}
                    onChange={setSelectedTeam}
                    disabled={!department}
                    emptyText="This department has no active teams"
                    footer={department
                      ? `${teamLists.length} active team${teamLists.length === 1 ? '' : 's'} in this department`
                      : 'Pick a department first'}
                  />
                </Grid>
                {(department === salesDepartment || department === designDepartment) && (
                  <Grid item xs={12} sm={6}>
                    {/* Matched to the two beside it - a plain select in the
                        middle of a row of contained ones reads as unfinished. */}
                    <SinglePicker
                      classes={classes}
                      label="Assistant Manager"
                      placeholder="Type to search"
                      options={amList}
                      value={am}
                      onChange={setSelectedAM}
                      idKey="id"
                      emptyText="No assistant manager in this department"
                      footer={`${amList.length} available · optional`}
                    />
                  </Grid>
                )}
                {department === salesDepartment && (
                  <Grid item xs={12} sm={6}>
                    <SinglePicker
                      classes={classes}
                      label="Sales Manager"
                      placeholder="Type to search"
                      options={smList}
                      value={sm}
                      onChange={setSelectedSM}
                      idKey="id"
                      emptyText="No sales manager in this department"
                      footer={`${smList.length} available · optional`}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  {/* One contained block per picker: the field, a count with
                      Select all / Clear, and the picks spelled out below it.
                      These were underline Selects whose only feedback was a
                      line of truncated text. */}
                  <div className={classes.pickerBox}>
                    <Autocomplete
                      multiple
                      size="small"
                      disableCloseOnSelect
                      limitTags={2}
                      options={dumpCities.map((c) => c.name)}
                      value={selectedCities}
                      // Routed through the same handler the picks below use,
                      // so dropping a city always drops the centres that are
                      // no longer in scope with it.
                      onChange={(e, v) => getExperienceCenterByLocation(v)}
                      renderOption={(option, { selected }) => (
                        <span className={classes.optionRow}>
                          <Checkbox size="small" color="primary" checked={selected} className={classes.optionCheck} />
                          {option}
                        </span>
                      )}
                      renderTags={(value, getTagProps) => value.map((option, index) => (
                        <Chip {...getTagProps({ index })} key={option} size="small" label={option} className={classes.pickedChip} />
                      ))}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Locations"
                          placeholder={selectedCities.length ? '' : 'Type to search'}
                        />
                      )}
                    />
                    <div className={classes.pickerFoot}>
                      <span className={classes.pickerCount}>
                        <b>{selectedCities.length}</b> of <b>{dumpCities.length}</b> selected
                      </span>
                      {dumpCities.length > 0 && selectedCities.length !== dumpCities.length && (
                        <span role="button" tabIndex={0} className={classes.pickerLink}
                          onClick={() => getExperienceCenterByLocation(dumpCities.map((c) => c.name))}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); getExperienceCenterByLocation(dumpCities.map((c) => c.name)); } }}>
                          Select all
                        </span>
                      )}
                      {selectedCities.length > 0 && (
                        <span role="button" tabIndex={0} className={classes.pickerLink}
                          onClick={() => getExperienceCenterByLocation([])}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); getExperienceCenterByLocation([]); } }}>
                          Clear
                        </span>
                      )}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={classes.pickerBox}>
                    <Autocomplete
                      multiple
                      size="small"
                      disableCloseOnSelect
                      limitTags={2}
                      disabled={dumpExpcenters.length === 0}
                      options={dumpExpcenters.map((c) => c.name)}
                      value={selectedExpcenters}
                      onChange={(e, v) => setSelectedExpcenters(v)}
                      renderOption={(option, { selected }) => (
                        <span className={classes.optionRow}>
                          <Checkbox size="small" color="primary" checked={selected} className={classes.optionCheck} />
                          {option}
                        </span>
                      )}
                      renderTags={(value, getTagProps) => value.map((option, index) => (
                        <Chip {...getTagProps({ index })} key={option} size="small" label={option} className={classes.pickedChip} />
                      ))}
                      noOptionsText="No centre matches that"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Experience Centres"
                          placeholder={
                            dumpExpcenters.length === 0
                              ? 'Pick a location first'
                              : (selectedExpcenters.length ? '' : 'Type to search')
                          }
                        />
                      )}
                    />
                    <div className={classes.pickerFoot}>
                      <span className={classes.pickerCount}>
                        <b>{selectedExpcenters.length}</b> of <b>{dumpExpcenters.length}</b> selected
                      </span>
                      {dumpExpcenters.length > 0 && selectedExpcenters.length !== dumpExpcenters.length && (
                        <span role="button" tabIndex={0} className={classes.pickerLink}
                          onClick={() => setSelectedExpcenters(dumpExpcenters.map((c) => c.name))}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelectedExpcenters(dumpExpcenters.map((c) => c.name)); } }}>
                          Select all
                        </span>
                      )}
                      {selectedExpcenters.length > 0 && (
                        <span role="button" tabIndex={0} className={classes.pickerLink}
                          onClick={() => setSelectedExpcenters([])}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelectedExpcenters([]); } }}>
                          Clear
                        </span>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>

              {!isEdit && (
                <>
                  <div className={classes.sectionLabel} style={{ marginTop: 18 }}>
                    <SecurityIcon style={{ fontSize: 14 }} /> Password <span className={classes.sectionRule} />
                  </div>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Password" size="small" fullWidth value={password} name="password"
                        type={showPw.password ? 'text' : 'password'}
                        onChange={changeHandler} variant="outlined"
                        error={isPasswordShort}
                        helperText={isPasswordShort ? 'At least 8 characters' : ' '}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton size="small" onClick={() => setShowPw((p) => ({ ...p, password: !p.password }))} aria-label="toggle password">
                                {showPw.password ? <VisibilityOffIcon style={{ fontSize: 17 }} /> : <VisibilityIcon style={{ fontSize: 17 }} />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {password.length > 0 && (
                        <>
                          <div className={classes.strengthTrack}>
                            <div className={classes.strengthFill} style={{ width: `${strength.score}%`, background: strength.color }} />
                          </div>
                          <div style={{ fontSize: 11.5, fontWeight: 700, color: strength.color, marginTop: 4 }}>
                            {strength.label}
                          </div>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Confirm Password" size="small" fullWidth value={confirmPassword} name="confirmPassword"
                        type={showPw.confirmPassword ? 'text' : 'password'}
                        onChange={changeHandler} variant="outlined"
                        error={!isConfirmPasswordMatched}
                        helperText={!isConfirmPasswordMatched ? 'Passwords do not match' : ' '}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton size="small" onClick={() => setShowPw((p) => ({ ...p, confirmPassword: !p.confirmPassword }))} aria-label="toggle password">
                                {showPw.confirmPassword ? <VisibilityOffIcon style={{ fontSize: 17 }} /> : <VisibilityIcon style={{ fontSize: 17 }} />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <Button className={classes.btnGhost} onClick={closeUserModal} disabled={savingUser}>Cancel</Button>
          {isEdit ? (
            <Button
              className={classes.btnPrimary}
              onClick={editUser}
              startIcon={savingUser ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : <EditIcon style={{ fontSize: 16 }} />}
              disabled={savingUser || loadingUser || !(name && mobile && email)}
            >
              {savingUser ? 'Saving…' : 'Update'}
            </Button>
          ) : (
            <Button
              className={classes.btnPrimary}
              onClick={addUser}
              startIcon={savingUser ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : <PersonAddIcon style={{ fontSize: 16 }} />}
              disabled={
                savingUser || !(name && mobile && email && password && confirmPassword)
                || isPasswordShort || !isConfirmPasswordMatched
                || ['Very Weak', 'Weak'].includes(strength.label)
              }
            >
              {savingUser ? 'Creating…' : 'Add User'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* ------------------------------ delete ------------------------------ */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth classes={{ paper: classes.dlgPaper }}>
        <div className={`${classes.dlgHead} ${classes.dlgHeadDanger}`}>
          <div className={classes.dlgHeadIcon}><DeleteOutlineIcon /></div>
          <div>
            <div className={classes.dlgTitle}>Delete User?</div>
            <div className={classes.dlgSub}>This cannot be undone</div>
          </div>
          <IconButton size="small" className={classes.dlgClose} onClick={() => setOpen(false)} aria-label="close">
            <ClearIcon fontSize="small" />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <DialogContentText style={{ fontSize: 14, color: INK }}>
            This permanently removes the account. If you only want to stop them signing in,
            deactivate the user instead — that keeps their history intact.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <Button className={classes.btnGhost} onClick={() => setOpen(false)} disabled={deleting}>Cancel</Button>
          <Button
            className={classes.btnDanger}
            onClick={handleUserDelete}
            disabled={deleting}
            startIcon={deleting ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : <DeleteOutlineIcon style={{ fontSize: 16 }} />}
          >
            {deleting ? 'Deleting…' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------------ roles ------------------------------- */}
      <Modal
        title={`Roles — ${userDetails.name || ''}`}
        centered
        visible={rolesModal}
        onCancel={() => setRolesModal(false)}
        width={1000}
        maskClosable={false}
        footer={null}
        // One scroll region for the whole body, not a 46vh box nested inside
        // it. A nested scroller meant the role list got a sliver of the modal
        // while the space above it sat fixed.
        bodyStyle={{ maxHeight: '74vh', overflowY: 'auto' }}
      >
        {rolesLoading ? (
          <>
            <BrandLinearProgress />
            <div style={{ padding: '10px 0' }}>
              {[...Array(6)].map((_, i) => <Skeleton key={i} height={34} />)}
            </div>
          </>
        ) : (() => {
          const all = rolesList || [];
          const term = roleSearch.trim().toLowerCase();
          const matches = (r) => !term || String(r?.name || '').toLowerCase().includes(term);
          // Split from the SAME list the switches render, so the summary at the
          // top can never disagree with the toggles below it.
          const assigned = all.filter((r) => selectedUserRoles.includes(r.name));
          const available = all.filter((r) => !selectedUserRoles.includes(r.name));
          const shownAssigned = assigned.filter(matches);
          const shownAvailable = onlyAssigned ? [] : available.filter(matches);

          const roleCard = (role) => {
            const on = selectedUserRoles.includes(role.name);
            const busyRole = roleBusy === role.name;
            return (
              <Grid item xs={12} sm={6} md={4} key={role._id || role.name}>
                <div className={`${classes.roleRow} ${on ? classes.roleRowOn : ''}`}>
                  {/* One spinner per role, not a page-wide block - toggling
                      "Sales User" should not freeze the other twenty rows. */}
                  {busyRole
                    ? <CircularProgress size={18} thickness={5} style={{ color: ORANGE_DARK, margin: 3 }} />
                    : (
                      <Switch
                        size="small"
                        color="primary"
                        checked={on}
                        disabled={Boolean(roleBusy)}
                        onChange={() => handleRoleToggle(!on, role.name)}
                      />
                    )}
                  <span className={classes.roleName}>{role?.name}</span>
                </div>
              </Grid>
            );
          };

          return (
            <>
              <div className={classes.roleUserCard}>
                <Avatar className={classes.roleUserAvatar}>
                  {String(userDetails.name || '?').trim().charAt(0).toUpperCase()}
                </Avatar>
                <div style={{ minWidth: 0 }}>
                  <div className={classes.roleUserName}>{userDetails.name || '—'}</div>
                  <div className={classes.roleUserMeta}>
                    {userDetails.email && <span><MailOutlineIcon style={{ fontSize: 12, verticalAlign: 'middle', marginRight: 4 }} />{userDetails.email}</span>}
                    {departmentorEffectiveDate && <span><BusinessIcon style={{ fontSize: 12, verticalAlign: 'middle', marginRight: 4 }} />{departmentorEffectiveDate}</span>}
                  </div>
                </div>
              </div>

              <div className={`${classes.assignedBox} ${assigned.length === 0 ? classes.assignedBoxEmpty : ''}`}>
                <div className={classes.roleGroupLabel} style={{ margin: '0 0 9px' }}>
                  <CheckCircleIcon style={{ fontSize: 14, color: assigned.length ? GREEN_DARK : '#9aa5b1' }} />
                  Currently assigned
                  <span className={classes.roleGroupCount}>{assigned.length}</span>
                </div>
                {assigned.length === 0 ? (
                  <div style={{ fontSize: 12.5, color: '#636c7a' }}>
                    No roles yet — this person can sign in but will not see any menus.
                    Turn one on below.
                  </div>
                ) : (
                  <div className={classes.assignedChips}>
                    {/* Deletable, so taking a role away does not mean hunting
                        for its switch in a list of fifty. */}
                    {assigned.map((role) => (
                      <Chip
                        key={role._id || role.name}
                        size="small"
                        label={role.name}
                        className={classes.assignedChip}
                        disabled={Boolean(roleBusy)}
                        onDelete={roleBusy ? undefined : () => handleRoleToggle(false, role.name)}
                        deleteIcon={roleBusy === role.name
                          ? <CircularProgress size={13} thickness={6} style={{ color: GREEN_DARK, marginRight: 6 }} />
                          : undefined}
                      />
                    ))}
                  </div>
                )}
              </div>

              <div className={classes.roleToolbar}>
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search roles"
                  value={roleSearch}
                  onChange={(e) => setRoleSearch(e.target.value)}
                  style={{ minWidth: 240, flex: '0 1 320px' }}
                  InputProps={{
                    classes: { root: classes.searchInputRoot },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: '#9aa5b1', fontSize: 18 }} />
                      </InputAdornment>
                    ),
                    endAdornment: roleSearch ? (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => setRoleSearch('')} aria-label="clear">
                          <ClearIcon style={{ fontSize: 15 }} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
                <FormControlLabel
                  style={{ margin: 0 }}
                  control={
                    <Switch size="small" color="primary" checked={onlyAssigned} onChange={(e) => setOnlyAssigned(e.target.checked)} />
                  }
                  label={<span style={{ fontSize: 12.5, fontWeight: 600, color: '#5f6876' }}>Assigned only</span>}
                />
                <span style={{ marginLeft: 'auto', fontSize: 12, color: '#5f6876', fontWeight: 600 }}>
                  {all.length} roles in total
                </span>
              </div>

              <div className={classes.roleScroll}>
                {shownAssigned.length > 0 && (
                  <>
                    <div className={classes.roleGroupLabel}>
                      <CheckCircleIcon style={{ fontSize: 14, color: GREEN_DARK }} />
                      Assigned
                      <span className={classes.roleGroupCount}>{shownAssigned.length}</span>
                      <span className={classes.sectionRule} />
                    </div>
                    <Grid container spacing={1}>{shownAssigned.map(roleCard)}</Grid>
                  </>
                )}

                {shownAvailable.length > 0 && (
                  <>
                    <div className={classes.roleGroupLabel}>
                      <SecurityIcon style={{ fontSize: 14, color: '#9aa5b1' }} />
                      Available
                      <span className={classes.roleGroupCount}>{shownAvailable.length}</span>
                      <span className={classes.sectionRule} />
                    </div>
                    <Grid container spacing={1}>{shownAvailable.map(roleCard)}</Grid>
                  </>
                )}

                {shownAssigned.length === 0 && shownAvailable.length === 0 && (
                  <div className={classes.roleEmpty}>
                    {onlyAssigned && assigned.length === 0
                      ? 'No roles are assigned yet. Turn off “Assigned only” to pick one.'
                      : <>No role matches “{roleSearch.trim()}”.</>}
                  </div>
                )}
              </div>
            </>
          );
        })()}
      </Modal>

      {/* --------------------------- promotional ---------------------------- */}
      <Dialog open={promoModalOpen} onClose={handleClosePromoModal} fullWidth maxWidth="xs" classes={{ paper: classes.dlgPaper }}>
        <div className={classes.dlgHead}>
          <div className={classes.dlgHeadIcon}><StarsIcon /></div>
          <div style={{ minWidth: 0 }}>
            <div className={classes.dlgTitle}>Promotional Role</div>
            <div className={classes.dlgSub}>{selectedUserName}</div>
          </div>
          <IconButton size="small" className={classes.dlgClose} onClick={handleClosePromoModal} aria-label="close">
            <ClearIcon fontSize="small" />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <TextField select label="Month" fullWidth margin="normal" size="small" variant="outlined" value={promoMonth} onChange={(e) => setPromoMonth(Number(e.target.value))}>
            {months.map((month) => (
              <MenuItem key={month} value={month}>
                {`${month} — ${new Date(0, month - 1).toLocaleString('default', { month: 'long' })}`}
              </MenuItem>
            ))}
          </TextField>
          <TextField select label="Year" fullWidth margin="normal" size="small" variant="outlined" value={promoYear} onChange={(e) => setPromoYear(e.target.value)}>
            {years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)}
          </TextField>
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <Button className={classes.btnGhost} onClick={handleClosePromoModal} disabled={promoSaving}>Cancel</Button>
          <Button
            className={classes.btnPrimary}
            onClick={handlePromoSubmit}
            disabled={!promoMonth || !promoYear || promoSaving}
            startIcon={promoSaving ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : <StarsIcon style={{ fontSize: 16 }} />}
          >
            {promoSaving ? 'Assigning…' : 'Assign'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* -------------------------- effective date -------------------------- */}
      <Dialog open={effectiveDateModal} onClose={() => setEffectiveDateModal(false)} maxWidth="xs" fullWidth classes={{ paper: classes.dlgPaper }}>
        <div className={classes.dlgHead}>
          <div className={classes.dlgHeadIcon}><SecurityIcon /></div>
          <div style={{ minWidth: 0 }}>
            <div className={classes.dlgTitle}>Effective From</div>
            <div className={classes.dlgSub}>{selectedRole} · {departmentorEffectiveDate}</div>
          </div>
          <IconButton size="small" className={classes.dlgClose} onClick={() => setEffectiveDateModal(false)} aria-label="close">
            <ClearIcon fontSize="small" />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <TextField
            name="startDate" label="From Date" type="date" value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }} fullWidth size="small" variant="outlined"
          />
          <div className={classes.warnBox}>
            <WarningRoundedIcon style={{ fontSize: 17, flexShrink: 0, marginTop: 1 }} />
            <span>Design and Sales roles are dated, because targets and incentives are calculated from the day the role starts.</span>
          </div>
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <Button className={classes.btnGhost} onClick={() => setEffectiveDateModal(false)} disabled={Boolean(roleBusy)}>Cancel</Button>
          <Button
            className={classes.btnPrimary}
            onClick={handleSaveEffectiveDate}
            disabled={!startDate || Boolean(roleBusy)}
            startIcon={roleBusy ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : null}
          >
            {roleBusy ? 'Saving…' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------ activate / deactivate --------------------- */}
      <Dialog open={openDeactivateDialog} onClose={handleCloseDeactivate} maxWidth="sm" fullWidth classes={{ paper: classes.dlgPaper }}>
        <div className={`${classes.dlgHead} ${selectedUser?.isActive ? classes.dlgHeadDanger : ''}`}>
          <div className={classes.dlgHeadIcon}>{selectedUser?.isActive ? <BlockIcon /> : <CheckCircleIcon />}</div>
          <div style={{ minWidth: 0 }}>
            {/* The old dialog always said "Deactivate User", including when
                the click was going to REACTIVATE someone. */}
            <div className={classes.dlgTitle}>{selectedUser?.isActive ? 'Deactivate User' : 'Reactivate User'}</div>
            <div className={classes.dlgSub}>{selectedUser?.name || ''}</div>
          </div>
          <IconButton size="small" className={classes.dlgClose} onClick={handleCloseDeactivate} aria-label="close">
            <ClearIcon fontSize="small" />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <DialogContentText style={{ fontSize: 14, color: INK, marginBottom: 0 }}>
            {selectedUser?.isActive
              ? <>Stop <b>{selectedUser?.name}</b> signing in and hand their work over?</>
              : <>Give <b>{selectedUser?.name}</b> access again?</>}
          </DialogContentText>
          {selectedUser?.isActive && (
            <div className={classes.warnBox}>
              <WarningRoundedIcon style={{ fontSize: 17, flexShrink: 0, marginTop: 1 }} />
              <span>
                All of their leads and projects are reassigned to the next active manager above them.
                That reassignment is not reversed by reactivating the account.
              </span>
            </div>
          )}
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <Button className={classes.btnGhost} onClick={handleCloseDeactivate} disabled={statusSaving}>Cancel</Button>
          <Button
            className={selectedUser?.isActive ? classes.btnDanger : classes.btnPrimary}
            onClick={setIsActiveUser}
            disabled={statusSaving}
            startIcon={statusSaving ? <CircularProgress size={15} thickness={5} style={{ color: '#fff' }} /> : null}
          >
            {statusSaving ? 'Saving…' : (selectedUser?.isActive ? 'Deactivate' : 'Reactivate')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo, getAllRoles })(Users);
